// Transaction-related constants
export const TRANSACTION_TYPES = {
    EXPENSE: 'expense',
    INCOME: 'income',
    TRANSFER: 'transfer',
  };
  
  export const TRANSACTION_STATUS = {
    PENDING: 'pending',
    COMPLETED: 'completed',
    FAILED: 'failed',
    CANCELLED: 'cancelled',
  };
  
  export const TRANSACTION_CATEGORIES = {
    INCOME: [
      'salary',
      'business',
      'investment',
      'gift',
      'other',
    ],
    EXPENSE: [
      'housing',
      'transportation',
      'food',
      'utilities',
      'insurance',
      'healthcare',
      'savings',
      'personal',
      'entertainment',
      'miscellaneous',
    ],
  };
  
  export const PAYMENT_METHODS = {
    CREDIT_CARD: 'credit_card',
    DEBIT_CARD: 'debit_card',
    CASH: 'cash',
    BANK_TRANSFER: 'bank_transfer',
    MOBILE_PAYMENT: 'mobile_payment',
    OTHER: 'other',
  };